import React from 'react';
import { Text } from '@chakra-ui/react';
import { colorsGrey } from '@src/theme/chakraTheme/colors';

const SharedText: FCWithChildren = ({ children }) => (
  <Text
    ml={6}
    mb={0}
    color={colorsGrey[300]}
    fontFamily="montserrat"
    fontWeight="light"
  >
    {children}
  </Text>
);

export default SharedText;
